import { useMediaQuery } from "@mui/material"
import ProfileNav from "./profile-nav"
import { ProfileNavMobile } from "./profile-nav-mobile"
import { ProfileNavSidePane } from "./profile-nav-side-pane"
import { useContext, useEffect, useState } from "react"
import CountryContext from "./country_context"
import { Profile_Not_Logged_In } from "./profile_not_logged_in"

export const ProfileWrapper = (props) => {
    const context = useContext(CountryContext)

    const [mobileView, setMobileView] = useState(false)
    const matches = useMediaQuery('(max-width:770px)');

    useEffect(() => {
        console.log('width changed')
        if (matches) {
            setMobileView(true)
        }
        else {
            setMobileView(false)
        }

    }, [matches])    
    return(
        <div className=''>
        {context.user ?
            <div >
                {/* <ProfileNav /> */}
                {/* <NavTest /> */}
                {mobileView ? <ProfileNavMobile /> : <ProfileNav />}
                <div className={` row 
                     align-items-start justify-content-center
                     pt-2 profile-body-light `}>
                    {!mobileView &&
                        <div className='col-md-2'>
                            <ProfileNavSidePane />
                        </div>
                        }

                    <div className='col-md-10  align-items-start
                     justify-content-center  py-2 bg-white px-5' style={{ borderRadius: "15px" }}>
                        {props.children}
                    </div>

                </div>

            </div>


            : <Profile_Not_Logged_In />}


    </div>
    )
}